import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface MaintenanceScreenProps {
  open?: boolean;
  onClose?: () => void;
}

const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({
  open = true,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    onClose?.();
    navigate("/");
  };

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose?.();
      }}
      disableEscapeKeyDown
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        tabIndex={-1}
        sx={{
          width: 464,
          height: 300,
          bgcolor: "#ffffff",
          borderRadius: "8px",
          boxSizing: "border-box",
          p: 3,
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <Typography
          sx={{
            mb: 2,
            fontWeight: 400,
            fontSize: 22,
            color: "#202224",
          }}
        >
          Atualização de indicadores
        </Typography>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            minHeight: 0,
          }}
        >
          <Typography variant="body1">
            Para proporcionar uma experiência completa estamos atualizando os
            seus indicadores.
          </Typography>
          <Typography variant="body1">
            Não se preocupe, seus dados estão seguros e você poderá
            visualizá-los em breve.
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBack}
            sx={{
              borderRadius: 9999,
              px: 3,
              py: 1,
              color: "#ffffff",
              textTransform: "none",
            }}
          >
            Voltar à tela inicial
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MaintenanceScreen;
